import { API_URL } from "constants/ApiUrl";
import React, { useEffect, useMemo, useState } from "react";
import { FaUserCircle, FaCheckCircle } from "react-icons/fa";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Spinner,
} from "reactstrap";
import image from "../../../assets/images/playMakerImage.png";
import { useNavigate } from "react-router-dom";
import { useAgent } from "hooks/useAgent";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "store/slices/agentSlice";

const AgentBanner = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { agent, loading, error } = useSelector((state) => state.Agent);

  const { activeSinceMonth, activeSinceYear } = useMemo(() => {
    if (!agent?.createdAt) {
      return { activeSinceMonth: null, activeSinceYear: null };
    }
    const date = new Date(agent.createdAt);
    return {
      activeSinceMonth: date.toLocaleString("default", { month: "long" }),
      activeSinceYear: date.getFullYear(),
    };
  }, [agent]);

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  if (loading) return <Spinner />;
  if (error) return <Alert color="danger">{error.message}</Alert>;

  return (
    <Row className="g-4">
      <Col xs="12" md="4">
        <Card className="h-100">
          <CardBody className="d-flex flex-column">
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "40px",
              }}
            >
              <FaUserCircle size={64} className="text-secondary" />
              <div>
                <div className="text-center mb-3">
                  <CardTitle tag="h5" className="mt-2">
                    {agent?.firstName + " " + agent?.lastName}
                  </CardTitle>
                  <small className="text-muted">
                    {t("dashboard.activeSince")} {activeSinceMonth}{" "}
                    {activeSinceYear}
                  </small>
                </div>
                <Button
                  onClick={() => navigate("/profile")}
                  color="primary"
                  outline
                  className="mb-4"
                >
                  {t("dashboard.editProfile")}
                </Button>
              </div>
            </div>
            <p className="flex-grow-1">
              {t("dashboard.verifieAccountRequest")}
            </p>
            <Button color="link" className="p-0 align-self-center">
              {t("dashboard.verifieAccount")} <FaCheckCircle className="ms-1" />
            </Button>
          </CardBody>
        </Card>
      </Col>

      <Col xs="12" md="8" className="d-none d-md-block">
        <Card className="h-100 text-white">
          <div className="position-relative" style={{ height: "100%" }}>
            <div
              className="text-center"
              style={{ height: "100%", overflow: "hidden" }}
            >
              <img
                src={image}
                alt="PlayMaker"
                style={{
                  objectFit: "contain",
                  width: "100%",
                  height: "100%",
                  objectPosition: "center",
                }}
              />
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default AgentBanner;
